import * as Storage from "./GetSetStorage";

// A scanned table is remembered for 2 hours of inactivity: every read slides the
// window forward, and the whole session is dropped as soon as the order is paid
// or completed, so a stale table can never be reused by the next customer.
// export const DINE_IN_SESSION_TTL = 30 * 1000;
export const DINE_IN_SESSION_TTL = 2 * 60 * 60 * 1000;

const QR_CODE_STRING_KEY = "QRCodeString";
const TABLE_NUMBER_KEY = "tableNumber";
const EXPIRES_AT_KEY = "dineInSessionExpiresAt";
const RUNNING_ORDER_SEEN_KEY = "dineInRunningOrderSeen";

export const clearDineInSession = () => {
    Storage.removeValueFromStorage(QR_CODE_STRING_KEY);
    Storage.removeValueFromStorage(TABLE_NUMBER_KEY);
    Storage.removeValueFromStorage(EXPIRES_AT_KEY);
    Storage.removeValueFromStorage(RUNNING_ORDER_SEEN_KEY);
};

const touchDineInSession = () => Storage.setValueToStorage(EXPIRES_AT_KEY, Date.now() + DINE_IN_SESSION_TTL);

// only true when an expiry exists and has passed - a session stored before this
// feature shipped has none, so it gets a fresh window on the next read
const isDineInSessionExpired = () => {
    const expiresAt = Storage.getParsedValueFromStorage(EXPIRES_AT_KEY);
    return Boolean(expiresAt) && Date.now() > expiresAt;
};

const readFromSession = (key) => {
    if (isDineInSessionExpired()) {
        clearDineInSession();
        return "";
    }
    const value = Storage.getParsedValueFromStorage(key);
    if (value) {
        touchDineInSession();
    }
    return value;
};

export const getQrCodeString = () => readFromSession(QR_CODE_STRING_KEY);

export const getTableNumber = () => readFromSession(TABLE_NUMBER_KEY);

export const setQrCodeString = (qrCodeString) => {
    Storage.setValueToStorage(QR_CODE_STRING_KEY, qrCodeString);
    touchDineInSession();
};

export const setTableNumber = (tableNumber) => {
    Storage.setValueToStorage(TABLE_NUMBER_KEY, tableNumber);
    touchDineInSession();
};

// remembering that an order existed lets us tell "not ordered yet" apart from
// "the bill was settled" the next time the running order call comes back empty
export const markRunningOrderSeen = () => Storage.setValueToStorage(RUNNING_ORDER_SEEN_KEY, true);

export const hasSeenRunningOrder = () => Boolean(Storage.getParsedValueFromStorage(RUNNING_ORDER_SEEN_KEY));
